import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AccessType } from '../../enums/enum.type';
import { AccessDetails, AppLevelAccess } from '../../models/models';
import { GetDataService } from '../../services/getdata.service';
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from '../../services/common.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css']
})
export class SideMenuComponent implements OnInit {

  @ViewChild('switchModalPopup') switchModalPopup: ElementRef|any;
  baseAssigned:{baseId:number,baseName:string}[]=[];
  currentBase:{baseId:number,baseName:string}={baseId:-1,baseName:''};

  currentBaseSubject = new BehaviorSubject({baseId:-1,baseName:''});
  appLevelAccess:AppLevelAccess={baseId:-1,accessLevel:{farmApp:null,warehouse:null,labApp:null,supplyDemand:null,
    qualityAccess:null,qualityInternalAccess:null,hseAccess:null,hseSummaryAccess:false,hseReportAccess:false
  }};


  constructor(private router:Router,private getDataService:GetDataService,private cookieService:CookieService,
    private commonService:CommonService) {
    this.getDataService.getAccessDetails().subscribe(response=>{
      if(response){
        this.accessDetails = response;
      }
    });
    this.getDataService.switchBasePopup.subscribe(response=>{
      if(response){
        this.switchModalPopup.nativeElement.click();
        this.getDataService.switchBasePopup.next(false);
      }
    })
    this.getBaseAssigned();
    this.currentBaseSubject.subscribe(response=>{
      this.currentBase = response;
    })
    this.commonService.currentBaseId.subscribe(currentBaseId=>{
      if(currentBaseId){
        this.getCurrentBase(currentBaseId);
      }
    });
    const currentBase = this.cookieService.get('currentBase');
    if(!currentBase){
      setTimeout(() => {
        this.switchModalPopup.nativeElement.click();
      }, 100);
    }
    this.commonService.currentBaseAppLevelAccess.subscribe(response=>{
      if(response){
        this.appLevelAccess = response;
        this.appLevelAccess.accessLevel.farmApp?localStorage.setItem('farm_access','true'):localStorage.removeItem('farm_access');
        this.appLevelAccess.accessLevel.warehouse?localStorage.setItem('warehouse_access','true'):localStorage.removeItem('warehouse_access');
        this.appLevelAccess.accessLevel.labApp?localStorage.setItem('lab_app_access','true'):localStorage.removeItem('lab_app_access');
        this.appLevelAccess.accessLevel.supplyDemand?localStorage.setItem('supply_demand_access','true'):localStorage.removeItem('supply_demand_access');
        this.appLevelAccess.accessLevel.qualityAccess?localStorage.setItem('quality_access','true'):localStorage.removeItem('quality_access');
        this.appLevelAccess.accessLevel.hseAccess?localStorage.setItem('hse_access','true'):localStorage.removeItem('hse_access');    
        this.appLevelAccess.accessLevel.hseSummaryAccess?localStorage.setItem('hse_summary_access','true'):localStorage.removeItem('hse_summary_access');
        this.appLevelAccess.accessLevel.hseReportAccess?localStorage.setItem('hse_report_access','true'):localStorage.removeItem('hse_report_access');
        this.appLevelAccess.accessLevel.qualityInternalAccess?localStorage.setItem('quality_internal_access',this.appLevelAccess.accessLevel.qualityInternalAccess):localStorage.removeItem('quality_internal_access');
      }
    })
  }

  AccessType = AccessType;
  accessDetails:AccessDetails = {accessType:AccessType.View,farmAccess:false,warehouseAccess:false,supplyDemandAccess:false,labAppAccess:false};
  ngOnInit(): void {
  }

  getBaseAssigned=()=>{
    const baseAssignedList = this.cookieService.get('baseAssignedList');
    if(!baseAssignedList){
      this.getDataService.getBaseId().subscribe(response=>{
        if(response && response.data){
          const baseDetails = response.data.base_details;
          baseDetails.forEach((item:any)=>{
            this.baseAssigned.push({baseId:item.id,baseName:item.base_name});
          });
          this.cookieService.set('baseAssignedList',JSON.stringify(this.baseAssigned));

          // get the current base name
          this.commonService.currentBaseId.subscribe(response=>{
            if(response){
              this.getCurrentBase(response);
            }
          })
        }
      })
    }
    else{
      this.baseAssigned = JSON.parse(baseAssignedList);
      // get the current base name
      let currentBase:any  = this.cookieService.get('currentBase');
      if(currentBase){
        currentBase = JSON.parse(currentBase);
        this.getCurrentBase(+currentBase.baseId);
      }
    }
  }

  onUpdateBase(baseId:number,baseName:string){
    this.getDataService.switchBase(baseId).subscribe(response=>{
      if(response){
        this.getCurrentBase(baseId);
        this.commonService.currentBaseId.next(baseId);
        if(baseId && baseId !=-1){
          localStorage.setItem('currentBaseId',baseId.toString());
        }
      }
      window.location.reload();
    },error=>{
      console.log('error on update base',error);
    })
  }

  getCurrentBase(currentBaseId:number){
    if(this.baseAssigned && this.baseAssigned.length>0 && currentBaseId){
      const index = this.baseAssigned.findIndex(item=>item.baseId == currentBaseId);
      if(index !=-1){
        this.currentBaseSubject.next(this.baseAssigned[index]);
        this.cookieService.set('currentBase',JSON.stringify(this.baseAssigned[index]));
        this.commonService.setBaseAccess(currentBaseId);
      }
    }
  }

  navigateToHse(){
    console.log('appLevelAccess',this.appLevelAccess);
    if(this.appLevelAccess.accessLevel.hseSummaryAccess){
      this.router.navigateByUrl('/hse');
    }
    else if(this.appLevelAccess.accessLevel.hseReportAccess){
      this.router.navigateByUrl('/hse/report');
    }
  }
}
